<template>
    <a-layout class="main">
        <Header/>
        <a-layout class="card main-card">
            <a-layout-sider width="150" class="left-menu" style="background: #fff">
                <Menu></Menu>
            </a-layout-sider>
            <a-layout class="main-brench">
                <keep-alive>
                    <router-view class="panel"/>
                </keep-alive>
            </a-layout>
        </a-layout>
    </a-layout>
</template>

<script>
import Header from '@/components/Header'
import Menu from './components/Menu.vue'

export default {
    components: {
        Header, Menu
    }
}
</script>

<style lang="less">
body {
    background-color: #e6e6e6 !important;
    min-width: 1000px;
}
@media screen and (max-width: 800px) {
    body {
        min-width: 100%;
    }
}
.main {
    height: 100%;
}
.panel {
    padding: 10px;
}
</style>

<style lang="less" scoped>
.ant-layout {
    background: none;
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    font-family: none;
}
.main-card {
    margin: 10px auto;
    width: 1000px;
}
.main-brench {
    background-color: #f6f6f6;
    padding: 10px;
}
@media screen and (min-width: 1000px) {
    // .stat-card-mobile {
    //     display: none;
    // }
}
@media screen and (max-width: 1000px) {
    .main-card {
        margin: 0;
        width: 100%;
    }
}
</style>